window.$components = {};

export default class Verra {

    static component(name, callback) {
        window.$components[name] = (data) => callback(data);
    }

    static property(name, callback) {
        if (!window.Alpine) {
            return;
        }

        Alpine.addMagicProperty(name, callback);
    }
};